/*  src/pages/UsersTable.jsx  */
import React,{useEffect,useState} from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Typography, Button, Paper } from '@mui/material';
import * as XLSX from 'xlsx';
import { api } from '../services/api';

export default function UsersTable(){
  const [rows,set] = useState([]);

  useEffect(()=>{
    api.get('/clientes')               // ← endpoint anterior
       .then(({data})=> set(data.map(c=>({
         id :c.id,
         nombre   :c.nombre,
         paterno  :c.ap_paterno,
         materno  :c.ap_materno,
         email    :c.email,
         afiliacion:c.afiliacion || '',
        region:    c.region     || '',
        verif:     c.email_verificado ? 'Sí' : 'No',
        creado:    new Date(c.created_at).toLocaleDateString('es-PE'),
       }))));
  },[]);

  const columns = [
    {field:'id',headerName:'ID',width:30},
    {field:'nombre',headerName:'Nombre',width: 120 },
    {field:'paterno',headerName:'Ap. paterno',width: 120 },
    {field:'materno',headerName:'Ap. materno',width: 120 },
    {field:'email',headerName:'Correo',width: 260 },
    { field: 'afiliacion', headerName: 'Afiliación', width: 130 },
    { field: 'region', headerName: 'Región', width:110 },
    { field: 'verif', headerName: 'Verificar', width: 85 },
    { field: 'creado', headerName: 'Fecha registro', width: 140 },
  ];

  const toExcel = ()=>{
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb,ws,'Usuarios');
    XLSX.writeFile(wb,'usuarios.xlsx');
  };

  return(
    <Box mt={8}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h4">Usuarios registrados</Typography>
        <Button onClick={toExcel} variant="contained">EXCEL</Button>
      </Box>
      <Paper sx={{height:420,mt:2}}>
        <DataGrid rows={rows} columns={columns} density="compact"/>
      </Paper>
    </Box>
  );
}
